var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF865C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20C11.3431 20 10 21.3431 10 23C10 23.5523 10.4477 24 11 24H21C21.5523 24 22 23.5523 22 23C22 21.3431 20.6569 20 19 20H13ZM8 23C8 20.2386 10.2386 18 13 18H19C21.7614 18 24 20.2386 24 23C24 24.6569 22.6569 26 21 26H11C9.34315 26 8 24.6569 8 23Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C14.3431 8 13 9.34315 13 11C13 12.6569 14.3431 14 16 14C17.6569 14 19 12.6569 19 11C19 9.34315 17.6569 8 16 8ZM11 11C11 8.23858 13.2386 6 16 6C18.7614 6 21 8.23858 21 11C21 13.7614 18.7614 16 16 16C13.2386 16 11 13.7614 11 11Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUserIcon);
export default __webpack_public_path__ + "static/media/new-user-icon.2046bb7b67cd4bad3dde6c8a11046060.svg";
export { ForwardRef as ReactComponent };